import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=27702348&scoped=true"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"
import style0 from "./Chats.vue?vue&type=style&index=0&id=27702348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27702348",
  null
  
)

export default component.exports